import React from 'react';
import * as AvatarPrimitive from '@radix-ui/react-avatar'

import * as S from './styles';

export type AvatarProps = React.ComponentProps<typeof AvatarPrimitive.Root> & {
  src?: string;
  alt: string;
  fallBack: string;
  borderColor: string;
  size: 'xs' | 'sm' | 'md' | 'lg',
}

export function Avatar (props: AvatarProps) {
  return (
    <S.Container variant={props.size} $borderColor={props.borderColor}>
      <S.StyledAvatarRoot variant={props.size} $borderColor={props.borderColor}>
        <S.StyledAvatarImage
          src={props.src}
          alt={props.alt}
        />
        <S.StyledAvatarFallback delayMs={600}>
          {props.fallBack}
        </S.StyledAvatarFallback>
      </S.StyledAvatarRoot>
    </S.Container>
  )
}



export default Avatar;